define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/store/Memory",
    "csi/config",
    "csi/def",
    "csi/form/Widget",
    "csi/locale",
    "csi/store/_base",
    "csi/xml",
    "csi/xml/Query"
    ], function(declare,lang,Memory,config,def,Widget,locale,csiStore,xml,Query) {
    return declare(Widget, {

    	FIELD_REFRESH_OR_RESET: "Option",
        FIELD_COST_TYPE: "UpdateCostScenarioCostType",

        _resolveView: function() {
            this.inherited(arguments);
        },

        _buildView: function() {
            this.addDefaultValue(this.FIELD_REFRESH_OR_RESET, "0");
            this.inherited(arguments);
        },

        getFieldStore: function(/*Field*/field, /*String*/value) {
            var store = this.inherited(arguments);

            switch(field.getControlName()){
                case this.FIELD_COST_TYPE:
                    return new Memory( {data:[
                        {id:0, name:locale.resource("UpdateCostScenarioMaterialCost")},
                        {id:1, name:locale.resource("UpdateCostScenarioOperationCost")},
                        {id:2, name:locale.resource("UpdateCostScenarioBothCosts")}
                    ]});
                case this.FIELD_REFRESH_OR_RESET:
                    return new Memory( {data:[
                        {id:0, name:locale.resource("Refresh")},
                        {id:1, name:locale.resource("Reset")}
                    ]});
            }
        }

    });
});